import OperationsHomePage, { columns1, columns2 } from './OperationsHomePage';

const operationsLinks = [...columns1, ...columns2];

export { operationsLinks };
export default OperationsHomePage;
